$(function () {
    var body = $('body');
    var wrapper = $('.wrapper');
    var nav = $('.nav');
    var menu_toggle = $('.menuToggle');
    var searchToggle = $('.searchToggleTrigger');
    var searchBar = $('.searchBarElement');
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');
    var child_menu_wrapper = $('.navwrap').find('.childMenuWrapper');
    var find_child_menu_trigger = $('.navwrap').find('.childMenuTrigger');
    var find_child_menu_tab = $('.navwrap').find('.childMenuTab');
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === "Escape") {
            nav_reset();
            menu_toggle.focus();
        }
    });

    nav_window.click(function (event) {
        nav_reset();
    });

    //menu_toggle click
    menu_toggle.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__menu-active')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    searchToggle.click(function (event) {
        nav_reset();
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        menu_toggle.removeClass('__active');
        nav_window.hide();
        body.removeClass('__menu-active');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul, div').removeClass('__active');
        find_child_menu_trigger.attr('aria-expanded', false).removeClass('__active');
        find_child_menu_tab.attr('aria-hidden', true).prop('hidden', true).removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__menu-active');
        nav_wrap.addClass('__active');
        searchBar.find('*[tabindex=0]').attr('tabindex', '-1');
        searchToggle.removeClass('__active');
        wrapper.removeClass('__searchactive');
        find_child_menu_trigger.eq(0).attr('aria-expanded', true).addClass('__active').focus();
        find_child_menu_tab.eq(0).attr('aria-hidden', false).prop('hidden', false).addClass('__active');
    };
    
    function initMenu() {
        var browser_width = window.innerWidth;

        if (browser_width >= break_point) {
            find_child_menu_trigger.click(function (event) {
                event.preventDefault();
                var dataSet = $(this).data('set');

                nav_wrap.find('.childMenuTrigger[aria-expanded="true"]').attr('aria-expanded', false).removeClass('__active');
                $(this).attr('aria-expanded', true).addClass('__active');

                nav_wrap.find('.childMenuTab.__active').attr('aria-hidden', true).prop('hidden', true).removeClass('__active');
                const child_menu_link = nav_wrap.find('.childMenuTab[data-set="' + dataSet + '"]')
                    .attr('aria-hidden', false)
                    .prop('hidden', false)
                    .addClass('__active');

                // Focus the first “real” item in that panel
                child_menu_link.find('.child-menu-item .govuk-link').first().trigger('focus');

                var child_menu_first = nav_wrap.find('.childMenuTab.__active .child-menu-item:first-child .govuk-link');
                if (child_menu_first.length) {
                    setTimeout(function () {
                        child_menu_first.trigger('focus');
                    }, 0);
                }
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".nav[aria-label='Primary']").length === 0) {
                    nav.find('.__active').removeClass('__active');
                    nav.find('[aria-expanded="true"]').attr('aria-expanded', false);
                }
            });

            function getActiveTrigger() {
                return nav_wrap.find('.childMenuTrigger[aria-expanded="true"]');
            }
            function getActivePanel() {
                return nav_wrap.find('.childMenuTab.__active');
            }
            function getTriggerBySet(n) {
                return nav_wrap.find('.childMenuTrigger[data-set="' + n + '"]');
            }
            function getPanelBySet(n) {
                return nav_wrap.find('.childMenuTab[data-set="' + n + '"]');
            }
            function getFirstActionable(panel) {
                return panel.find('.child-menu-item a.govuk-link, .child-menu-item button').first();
            }
            function getLastActionable(panel) {
                return panel.find('.child-menu-item a.govuk-link, .child-menu-item button').last();
            }
            function getCTA() {
                return nav_wrap.find('.menu-column-three .menu-cta-item').first();
            }
            function ensureFocusable($el) {
                if (!$el.length) return $el;
                if (!$el.is('a[href], button, [tabindex]:not([tabindex="-1"])')) {
                    $el.attr('tabindex', '0');
                }
                return $el;
            }

            // --- Click: switches tabs, then focuses first actionable item in panel ---
            find_child_menu_trigger.off('click.menu').on('click.menu', function (event) {
                event.preventDefault();

                var dataSet = $(this).data('set');

                // triggers
                nav_wrap.find('.childMenuTrigger[aria-expanded="true"]').attr('aria-expanded', false).removeClass('__active');
                $(this).attr('aria-expanded', true).addClass('__active');

                // panels
                nav_wrap.find('.childMenuTab.__active').attr('aria-hidden', true).prop('hidden', true).removeClass('__active');
                var panel = getPanelBySet(dataSet).attr('aria-hidden', false).prop('hidden', false).addClass('__active');

                // focus first actionable in the new panel
                var firstAction = getFirstActionable(panel);
                if (firstAction.length) {
                    setTimeout(function () { firstAction.trigger('focus'); }, 0);
                }
            });

            // --- Keyboard: Tab from last actionable in panel -> next trigger or CTA or toggle ---
            $(document).off('keydown.childnav').on(
                'keydown.childnav',
                '.childMenuTab.__active .child-menu-item a.govuk-link, .childMenuTab.__active .child-menu-item button',
                function (e) {
                    if (e.key !== 'Tab' || e.shiftKey) return;

                    var panel = getActivePanel();
                    var last = getLastActionable(panel);
                    if (!last.length || this !== last.get(0)) return;

                    e.preventDefault();

                    var currentTrigger = getActiveTrigger();
                    var currentSet = parseInt(currentTrigger.data('set'), 10);
                    var nextTrigger = getTriggerBySet(currentSet + 1);

                    if (nextTrigger.length) {
                        // Move to next trigger in the tablist
                        nextTrigger.trigger('focus');
                        return;
                    }

                    // No next trigger, try CTA then toggle
                    var cta = ensureFocusable(getCTA());
                    if (cta.length) {
                        cta.trigger('focus');
                    } else {
                        menu_toggle.trigger('focus');
                    }
                }
            );

            // --- Keyboard: from CTA, Tab -> menu_toggle; Shift+Tab -> last actionable in active panel ---
            $(document).off('keydown.ctaNav').on('keydown.ctaNav', '.menu-cta-item', function (e) {
                if (e.key !== 'Tab') return;

                var panel = getActivePanel();
                if (e.shiftKey) {
                    var last = getLastActionable(panel);
                    if (last.length) {
                        e.preventDefault();
                        last.trigger('focus');
                    }
                } else {
                    e.preventDefault();
                    menu_toggle.trigger('focus');
                }
            });
        }

        if (browser_width < break_point) {
            menu_toggle.click(function (event) {
                body.toggleClass('__mobile-menu-active');
            });

            find_child_menu_trigger.click(function (event) {
                event.preventDefault();
                var dataSet = $(this).data('set');

                child_menu_wrapper.addClass('__active');

                nav_wrap.find('.childMenuTrigger[aria-expanded="true"]').attr('aria-expanded', false).removeClass('__active');
                $(this).attr('aria-expanded', true).addClass('__active');

                nav_wrap.find('.childMenuTab.__active').attr('aria-hidden', true).prop('hidden', true).removeClass('__active');
                const child_menu_link = nav_wrap.find('.childMenuTab[data-set="' + dataSet + '"]')
                    .attr('aria-hidden', false)
                    .prop('hidden', false)
                    .addClass('__active');

                // Focus the first “real” item in that panel
                child_menu_link.find('.child-menu-item .govuk-link').first().trigger('focus');

                var child_menu_first = nav_wrap.find('.childMenuTab.__active .child-menu-item:first-child .govuk-link');
                if (child_menu_first.length) {
                    setTimeout(function () {
                        child_menu_first.trigger('focus');
                    }, 0);
                }
            });
        };

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }

        var back_menu = $('.backto button');
        back_menu.click(function (event) {           
            event.preventDefault();
            event.stopPropagation();
            child_menu_wrapper.removeClass('__active');
            find_child_menu_tab.attr('aria-hidden', true).prop('hidden', true).removeClass('__active');
            nav_wrap.find('.childMenuTrigger.__active').focus();
        });
    }
    
    initMenu();

    $(window).on('resize', function(){
        initMenu();
    });

});
